import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { LanguagesDataContext } from "../../../../common/data/lookup-data-providers/LanguagesDataProvider";
import { useAdminMuxSpecificationApi } from "../../api/useAdminMuxSpecificationApi";
import {
    ensureDictionaryLanguageSpecification,
    ManzanitaMuxSpecificationLanguageMappingListingItem
} from "../language-mapping/ManzanitaMuxSpecificationLanguageMappingsSection";
import {
    createMuxSpecificationDashboardItem,
    defaultMuxSpecificationDashboardItem,
    ensureIsManzanitaMuxSpecification,
    MuxSpecificationDashboardItem
} from "../MuxSpecificationDashboardItem";
import { MuxSpecificationDashboardContext } from "./MuxSpecificationDashboardContext";

interface MuxSpecificationDashboardProviderProps {
    children: React.ReactNode;
}

export const MuxSpecificationDashboardProvider: React.FC<MuxSpecificationDashboardProviderProps> = ({
    children
}: MuxSpecificationDashboardProviderProps) => {
    const { getMuxSpecificationById } = useAdminMuxSpecificationApi();

    const { isLoading: areLanguagesLoading } = useContext(LanguagesDataContext);

    const { muxSpecificationId } = useParams<{ muxSpecificationId: string }>();

    const [muxSpecificationDashboardItem, setMuxSpecificationDashboardItem] = useState<MuxSpecificationDashboardItem>(
        defaultMuxSpecificationDashboardItem
    );
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        setIsLoading(true);

        getMuxSpecificationById(muxSpecificationId)
            .then((response) => {
                const dashboardItem = createMuxSpecificationDashboardItem(response);

                setMuxSpecificationDashboardItem(dashboardItem);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    const updateManzanitaLanguageSpecificationMapping = (item: ManzanitaMuxSpecificationLanguageMappingListingItem) => {
        const { id: languageId, soundtrackPid, subtitlePid } = item;

        const newDashboardItem = { ...muxSpecificationDashboardItem };

        ensureIsManzanitaMuxSpecification(newDashboardItem);
        ensureDictionaryLanguageSpecification(newDashboardItem.languageSpecification);

        newDashboardItem.languageSpecification.soundtrackLanguagePidDictionary[languageId] = soundtrackPid;
        newDashboardItem.languageSpecification.subtitleLanguagePidDictionary[languageId] = subtitlePid;

        setMuxSpecificationDashboardItem(newDashboardItem);
    };

    return (
        <MuxSpecificationDashboardContext.Provider
            value={{
                isLoading: isLoading || areLanguagesLoading,
                muxSpecificationDashboardItem,
                updateManzanitaLanguageSpecificationMapping
            }}
        >
            {children}
        </MuxSpecificationDashboardContext.Provider>
    );
};
